<template>
    <Main>
        <div slot="main" class="main breeder">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span>
                </div>

            </div>
            <div class="content" v-if="refreShow">
                <div class="left">
                    <div class="l_t">
                        <div class="server">
                            <div>
                                <span class="card_">养殖户增长趋势</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date">
                                <span @click="serviceStatusBtn('first')"
                                    :class="{ active: serviceStatus === 'first' }">近1月</span>
                                <span @click="serviceStatusBtn('three')"
                                    :class="{ active: serviceStatus === 'three' }">近3月</span>
                                <span @click="serviceStatusBtn('six')"
                                    :class="{ active: serviceStatus === 'six' }">近6月</span>
                            </div>
                        </div>
                        <div class="add">
                            <div class="add_item">
                                <span class="num">{{ data_Map.newlyIncrease }}</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>累计新增</span>
                                    <span :class="{ active_1: data_Map.flag == 0 }">环比 <i>{{
                                        data_Map.linkRelativeRadio
                                    }}</i>
                                    </span>
                                    <img v-if="data_Map.flag === 1" src="../../assets/icon_down_1.png" alt="">
                                    <img v-else src="../../assets/icon_up_1.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div id="lineChart" class="line_chart"></div>
                    </div>
                    <div class="l_b">
                        <div class="server">
                            <div>
                                <span class="card_">养殖规模分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div id="barChart" class="bar_chart"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="top">
                        <div class="map_box">
                            <div class="server">
                                <div>
                                    <span class="card_">养殖户区域分布</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <div class="center">
                                <div class="text_n">
                                    <!-- <span>{{ farmerData.value }}</span> -->
                                    <dv-digital-flop :config="config2"
                                        style="min-width:1.5rem;height:0.5rem;margin-left:-0.28rem" />
                                    <!-- <span style="min-width:1.5rem;height:0.5rem;line-height: 0.4rem;">{{ total }}</span> -->
                                    <span>养殖户(家)</span>
                                </div>
                                <div class="text_n">
                                    <!-- <span>{{ farmerData.properties ? farmerData.properties : 0
                                                    }}</span> -->
                                    <dv-digital-flop :config="config3"
                                        style="min-width:1rem;height:0.5rem;margin-left:-1.35rem" />
                                    <span>畜牧科技师服务养殖户比例</span>
                                    <!-- <span>畜牧科技师服务养殖户{{ headDate != '/xnlogin' ? '数' : '比例' }}</span> -->
                                </div>
                            </div>
                            <div v-if="isShowMap" id="mapBox"></div>
                        </div>
                        <div class="ranght">
                            <div class="server">
                                <div>
                                    <span class="card_">养殖户类型分布</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <dv-active-ring-chart :config="config1" id="pieChart" />
                            <div class="lenged">
                                <div v-for="(item, i) in farmerKindDis" :key="i">
                                    <span :style='{
                                        backgroundColor: i == 0 ? "#3AFFFB" : i == 1 ? "#7239EA" : i == 2 ? "#FFC700" : "#165DFF"
                                    }'></span>
                                    <span>{{ item.name }}</span>
                                    <span>{{ item.value + '家' }}</span>
                                </div>
                                <!-- <div>
                                                    <div  style="width:50%" v-for="(item, i) in list" :key="i">
                                                        <span :style='{
                                                            backgroundColor: i == 0 ? "#3AFFFB" : i == 1 ? "#7239EA" : i == 2 ? "#FFC700" : "#165DFF"
                                                        }'></span>
                                                        <span>{{ item.value }}</span>
                                                    </div>
                                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="server">
                            <div>
                                <span class="card_">养殖户监管信息查询</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <span class="total">共计<i>{{ total }}</i>个</span>
                        </div>
                        <div class="search" style="padding: 0 0.25rem;">
                            <el-cascader v-show="headDate != '/nmzlqlogin'" placeholder="所在地域"
                                style="margin-right: 0.2rem; font-size:0.13rem" :props="{ checkStrictly: true }"
                                v-model="address" :options="baseArea">
                            </el-cascader>
                            <el-select v-show="headDate != '/nmzlqlogin'" v-model="userType" placeholder="养殖户类型"
                                style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="img" style="position: relative;">
                                <img style="width:.23rem;height:.23rem;position: absolute; top: 0.1rem;left: .1rem;"
                                    src="../../assets/search (1).png" alt="">
                                <el-input class="search_input" id="myinput" style="width: 4.2rem;" v-model="userName"
                                    @focus="focus" @blur="blur" placeholder="输入养殖户名称/畜牧科技师姓名检索">
                                </el-input>
                            </div>
                            <div class="btn btn_1" @click="getList">搜索</div>
                            <div class="reset_btn btn_1" @click="reset">重置</div>
                            <div v-if="(this.total > 10)" class="left_ l_f" @click="btnClick('left')"
                                :class="{ active_2: status === 'left' }">
                                <span class="el-icon-arrow-left"></span>
                            </div>
                            <div v-if="(this.total > 10)" class="right_ l_f" @click="btnClick('right')"
                                :class="{ active_2: statusRight === 'right' }">
                                <span class="el-icon-arrow-right"></span>
                            </div>
                        </div>
                        <dv-scroll-board :config="config" @click="details"
                            style="width:17.21rem;height:3.3rem;padding: 0 0.25rem;" />
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>
        </div>
    </Main>
</template>
  
<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";
import cityJson from "@/assets/js/city.js";
export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            chart: null,
            isShowMap: true,
            config: {},
            config1: {},
            config2: {},
            config3: {},
            baseArea: cityJson,
            // userTypeList: [
            //     { value: '0', label: '大型养殖场' },
            //     { value: '1', label: '个体养殖户' },
            //     { value: '2', label: '专业养殖户' },
            //     { value: '3', label: '小型养殖场' },
            // ],
            userTypeList: [
                { value: '0', label: '个人牧场' },
                { value: '1', label: '租赁牧场' },
                { value: '2', label: '企业养殖场' },
                { value: '3', label: '合作社' },
                { value: '4', label: '家庭牧场' },
                { value: '5', label: '集体经济养殖户' },
                { value: '6', label: '普通养殖户' },
                { value: '7', label: '国有牧场' },
            ],
            address: [],
            userType: '',
            userName: '',
            headerInfo: {},
            userInfo: {},
            serviceStatus: 'first',
            status: '',
            statusRight: 'right',
            lineData: [],
            // 养殖户列表
            breederList: [],
            //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            // hasPreviousPage: false,//上一页
            // hasNextPage: false,//下一页
            region: {},
            screenData: {},
            dataMap: {}, // 养殖户增长趋势
            data_Map: {},//存储单个养殖户增长趋势
            breedingScaleProp: {}, // 养殖规模分布
            farmerKindDis: [], // 养殖户类型分布
            farmerAreaDis: {},//地图数据
            farmerData: {
                value: '',
                properties: ''
            },
            breeList: [],//存储表格数据
            mapData: [],//地图数据
            goBackShow: false,//上一层
            refreShow: true,
            num1: 0,
            num2: 0,
            pages: '',
            headDate: '',//判断是否为正蓝旗登录

            mapDistance:90, //地图缩放距离
            mapDistance2:110 //子地图缩放距离
        };
    },
    watch: {},
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.address = JSON.parse(window.localStorage.getItem('ADDRESS'));
        this.baseArea = this.baseArea.filter(item => {
            return item.label == '内蒙古自治区'
        })
        // ---------------------
        // 获取养殖户类型分布
        // this.getPieData()
    },
    mounted() {
        this.getBreederList()
        this.getData()
    },
    methods: {
        getPieData() {
            let provinceId = ''
            let countId = ''
            let cityId = ''
            if (this.address.length > 0) {
                provinceId = this.address[0]
                cityId = this.address[1] ? this.address[1] : ''
                countId = this.address[2] ? this.address[2] : ''
            }
            this.$http({
                url: 'screenapp-service/aErShan/farmerKinds',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    provinceId: provinceId,
                    countyId: countId,
                    cityId: cityId,
                    name: '',
                    farmerTypeCode: '',
                    pageNum: 1,//第几页
                    pageSize: 5000,//一页几条
                    "dataFlag": 1,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    console.log(data, '44444');
                    // this.farmerKindDis = screenData.farmerKindDis
                    // this.farmerKindDis = this.farmerKindDis.map(item => {
                    //     item.value = +item.proportion
                    //     item.name = item.title
                    //     return item
                    // })
                    // this.config1 = {
                    //     data: this.farmerKindDis,
                    //     color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                    //     radius: '65%',
                    //     activeRadius: '70%',
                    //     lineWidth: 35,
                    //     digitalFlopStyle: {
                    //         fontSize: 20
                    //     },
                    //     activeTimeGap: 2000,
                    //     // digitalFlopToFixed:2
                    //     // showOriginValue:true
                    // }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        focus() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = ''

        },
        blur() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = '输入养殖户名称/畜牧科技师姓名检索'
        },
        // 返回上一层
        goBack() {
            this.goBackShow = false
            this.refreShow = false
            this.$nextTick(() => {
                this.refreShow = true
                this.getData()
            })
            // this.$router.go(0)
        },
        // 跳转养殖户详情
        details(val) {
            // console.log(this.breeList[val.rowIndex]);
            window.localStorage.setItem('MYINFO', JSON.stringify(this.breeList[val.rowIndex]))
            this.$router.push({ name: 'detailsXn' })
        },
        serviceStatusBtn(val) {
            if (val === 'first') {
                this.serviceStatus = 'first'
                this.data_Map = this.dataMap.oneMonth
            }
            if (val === 'three') {
                this.serviceStatus = 'three'
                this.data_Map = this.dataMap.threeMonth
            }
            if (val === 'six') {
                this.serviceStatus = 'six'
                this.data_Map = this.dataMap.sixMonth
            }
            this.lineData = []
            this.lineData.push({ name: '养殖户家数', value: this.data_Map.value, month: this.data_Map.label })
            this.setLineData(this.lineData, 'lineChart')
        },
        // 重置
        reset() {
            this.address = JSON.parse(window.localStorage.getItem('ADDRESS'));
            this.userType = '';
            this.userName = '';
            this.status = ''
            this.statusRight = 'right'
            this.pageNum = 1
            this.getBreederList()
        },
        // 翻页
        btnClick(val) {
            // if (val === 'left') {
            //     if (this.hasPreviousPage) {
            //         this.status = 'left'
            //         if(this.pageNum>1)  this.pageNum--
            //         this.getBreederList()
            //     } else {
            //         this.status = 'right'
            //     }
            // }
            if (val === 'left') {
                if (this.pageNum > 1) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    // if (this.pageNum > 1)
                    this.pageNum--
                    this.pageNum == 1 ? this.status = '' : this.status = 'left'
                    this.getBreederList()
                } else {
                    this.status = ''
                }
            }
            if (val === 'right') {
                if (this.pageNum < this.pages) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    // if(this.pageNum<Math.floor(this.total/this.pageSize))
                    this.pageNum++
                    this.pageNum == this.pages ? this.statusRight = '' : this.statusRight = 'right'
                    this.getBreederList()
                } else {
                    this.statusRight = ''
                }
            }
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "8%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        // console.log(params, 'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '家'
                            }</p>
                         `;
                        // return params.name
                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '养殖户家数',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 4],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            linechart.clear();
            linechart.setOption(option)
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
        // 牛羊只存栏柱状图
        setBarData(data) {
            var barchart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '家'
                            }</p>
                         `;
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '20%',
                    // 20
                    left: '3%',
                    right: '4%',
                    bottom: '1%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.label,
                },
                yAxis: {
                    name: '养殖户家数',
                    // name:this.cattleStatus=="cattle"?'数量(头)':'数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 4],
                        lineHeight: 45,
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00E0DB'
                    },
                    itemStyle: {
                        // opacity: 0.8,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#00E0DB"
                    },
                    data: data.value,
                },
            }
            barchart.clear();
            barchart.setOption(option)
            window.addEventListener('resize', () => {
                barchart.resize()
            })
        },
        // 搜索
        getList() {
            this.pageNum = 1
            this.status = ''
            this.statusRight = 'right'
            this.getBreederList()
        },
        // 获取养殖户列表
        getBreederList() {
            let provinceId = ''
            let countId = ''
            let cityId = ''
            if (this.address.length > 0) {
                provinceId = this.address[0]
                cityId = this.address[1] ? this.address[1] : ''
                countId = this.address[2] ? this.address[2] : ''
            }
            this.$http({
                url: 'screenapp-service/baseScreenFarmer/farmerList',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    provinceId: provinceId,
                    countyId: countId,
                    cityId: cityId,
                    name: this.userName,
                    farmerTypeCode: this.userType,
                    pageNum: this.pageNum,//第几页
                    pageSize: this.pageSize,//一页几条
                    "dataFlag": 1,
                },
            }).then(res => {
                this.breederList = []
                res.data.result.list.forEach((item, i) => {
                    for (var key in item) {
                        if (!item[key]) {
                            item[key] = '—'
                        }
                    }
                    this.breederList.push([i + 1, item.farmerName, item.farmerType, item.address, item.rearLiveStock, item.breedingNum, `<span style="border: 0.01rem solid rgba(0,117,126,0.3);padding:.05rem .1rem;color:#00D7D3;cursor:pointer;background: rgba(255, 255, 255, 0.1);">查看</span>`])
                })
                this.config = {
                    header: ['排序', '名称', '养殖户类型', '所在地域', '所属畜牧科技师', '养殖数量(头)', ''],
                    data: this.breederList,
                    align: ['center', 'left', 'left', 'left', 'left', 'right', 'center'],
                    columnWidth: [160, 180, 180, 320, 180, 180, 160],
                    headerHeight: 40,
                    waitTime: 2000
                }
                this.breeList = res.data.result.list
                this.total = res.data.result.total
                this.pages = res.data.result.pages
                // this.hasPreviousPage = res.data.result.hasPreviousPage,//上一页
                //     this.hasNextPage = res.data.result.hasNextPage//下一页
            }).catch(() => {
                this.config = { header: ['排序', '名称', '养殖户类型', '所在地域', '所属畜牧科技师', '养殖数量(头)', ''], data: [] }
                this.total = 0
            })
        },
        getData() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/select/other',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "4",
                    "menuMark": "3",
                    "dataFlag": "0",
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.headerInfo = { name: data.result.screenName }
                    this.dataMap = screenData.farmerGrowTrend.dataMap
                    this.data_Map = screenData.farmerGrowTrend.dataMap.oneMonth//默认显示一月
                    this.lineData = []
                    this.lineData.push({ name: '养殖户家数', value: this.data_Map.value, month: this.data_Map.label }),
                        this.breedingScaleProp = screenData.breedingScaleProp
                    this.farmerKindDis = screenData.farmerKindDis
                    this.farmerAreaDis = screenData.farmerAreaDis
                    this.mapData = this.farmerAreaDis.map
                    this.farmerData = {
                        value: this.farmerAreaDis.account,
                        properties: this.farmerAreaDis.proportion
                    }
                    if(screenData.mapDistance){
                        this.mapDistance = Number(screenData.mapDistance);
                    }
                    this.flopData()
                    // this.farmerAreaDis.map.forEach(item => {
                    //     item.name = item.city
                    //     item.value = item.account
                    // })
                    this.farmerKindDis = this.farmerKindDis.map(item => {
                        item.value = +item.proportion
                        item.name = item.title
                        return item
                    })
                    this.config1 = {
                        data: this.farmerKindDis,
                        color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                        radius: '65%',
                        activeRadius: '70%',
                        lineWidth: 35,
                        digitalFlopStyle: {
                            fontSize: 20
                        },
                        activeTimeGap: 2000,
                        digitalFlopToFixed:2
                        // showOriginValue:true
                    }
                    this.setLineData(this.lineData, 'lineChart')
                    this.setBarData(this.breedingScaleProp)
                    this.getMap()
                } else {
                    this.$message.error(data);
                }
            })
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    // deptId: "1571692293058125833",
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    if (this.region.features[0].properties.country == '正蓝旗') {
                        this.draws(this.region)
                    } else {
                        this.draw(this.region, this.farmerAreaDis.map)
                    }
                }
            })
        },
        // 正蓝旗
        draws(geoJson) {
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();


            var option = {
                tooltip: {
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                geo: {
                    show: true,
                    // roam: true,
                    type: "map", // 系列类型
                    name: "map", // 系列名称
                    zoom: 1.2,
                    map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    // data: data,
                    // selectedMode: 'multiple',
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    select: {
                        disabled: true,
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        },
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'top'
                        },
                    },
                    blur: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        }
                    },
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 8, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        // color: "rgba(33,80,231,1)", // 地图板块的颜色
                        color: '#0f3a67',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                        normal: { // 默认地图区域样式
                            // areaColor: 'rgba(33,80,231,1)',
                            areaColor: "#0f3a67",
                            // borderColor: "#4ECEE6",
                            borderColor: "#165d7d",
                            borderWidth: 1,
                            // shadowColor: "#2C99F6",
                            // shadowOffsetY: 0,
                            // shadowBlur: 25,
                        },
                    },
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: false,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter: function (params) {
                            //   // console.log(params)
                            //   return params.name
                            // }
                        },
                        itemStyle: {
                            "areaColor": "#1E88E5"
                        }
                    },
                },
                series: [
                    {
                        color: ['#1998fb'],
                        // type: 'scatter',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        effectType: 'ripple',
                        rippleEffect: {
                            color: '#00FFFF',
                            number: 3,
                            scale: 5,
                            brushType: 'stroke'
                        },
                        symbolSize: 5,
                        tooltip: {
                            show: false
                        },
                        data: [
                            {
                                name: '上都镇',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [0, 0],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, 10],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [40, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [60, -140],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [140, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [180, -180],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [150, -120],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [180, -100],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [200, -60],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [220, -180],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [20, -220],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [60, -240],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [140, -260],//点偏移
                            },
                        ]
                    },

                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        drawssss(geoJson, data) {
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.account
                    // item.value > this.num1 ? (this.num1 = item.value) : (this.num1 = 0)
                    // console.log(this.num1, 'this.num1');
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                this.num2 = Number(arrData[arrData.length - 1])
            }
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                grid: {
                    // top: '30%',
                    // height: "400px",
                    // containLabel: true,
                },
                select: {
                    disabled: true,
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    },
                    label: {
                        show: false,
                        color: '#fff',
                        position: 'top'
                    },
                },
                blur: {
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    }
                },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                        //         <p>
                        //  <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //         </p>
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1,
                        // roam: true,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 8, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 地图
        draw(geoJson, data) {
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.account
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num2 = Number(arrData[arrData.length - 1])
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
            }
            // data.forEach(item => {
            //     item.value = item.account
            // })
            // 基于准备好的dom，初始化echarts实例
            // document.getElementById("mapBox").innerHTML = ''
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                tooltip: {
                    show:false,
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                        <p style="color:#00E0DB;font-size: 20px;">${params.data.name}</p><br/>
                        <p>
                       <span style="color: #FFF; font-size: 14px; font-weight: normal;">养殖户<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">家</span> </span>
                              </p><br/>
                              <p>
                                  <span style="color: #FFF; font-size: 14px; font-weight: normal;">畜牧科技师服务养殖户占比<span style="color: #00E0DB; font-size: 16px;">${params.data.proportion || 0}</span></span>
                              </p>
                              `;
                        // return params.name
                    },
                },
                grid: {
                    // top: '-5%',
                    // show:true
                },
                series: [
                    {
                        type: "map3D", // 系列类型
                        name: "map3D", // 系列名称
                        zoom: 1,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        top: '-1%',
                        // bottom:'50%',
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 12, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            color: "#17478F", // 地图板块的颜色
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "color": "#00E0DB"
                            }
                        },
                        groundPlane: {
                            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                            show: false, // 是否显示地面。[ default: false ]
                            color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                        },
                        light: {
                            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                            main: {
                                // 场景主光源的设置，在 globe 组件中就是太阳光。
                                color: "#fff", //主光源的颜色。[ default: #fff ]
                                intensity: 1.2, //主光源的强度。[ default: 1 ]
                                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                            },
                        },

                        viewControl: {
                            // 用于鼠标的旋转，缩放等视角控制。
                            projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                            autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                            panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            orthographicSize: 60,
                            // distance: 200, 
                            distance:  this.mapDistance, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                            alpha: 70, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                            beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                            // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                            // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                            // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                            // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                            // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                            animation: true, // 是否开启动画。[ default: true ]
                            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                            animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                        },
                    },
                ],
                visualMap: {
                    show:false,
                    type: 'continuous',
                    // show: true,
                    min: 0,
                    max: this.num1 ? this.num1 * 4 : 0, //控制根据返回值  控制数量
                    right: 40,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${this.num2}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    inRange: {
                        color: this.num2 ? ['rgba(16,53,95,0.4)', 'rgba(250,219,114,1)', 'rgba(244,165,47,1)',
                            'rgba(242,150,43,1)', 'rgba(247,130,24,1)', 'rgba(249,105,33,1)'] : ['rgba(16,53,95,0.4)']  //显示颜色
                    },
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: [{
                        gte: this.num1 * 4,
                        label: `${this.num1 * 4}以上`,
                        // color: "#6b3e35"
                        color: "#f96921",
                        opacity: 1
                    }, {
                        gte: this.num1 * 3,
                        lte: this.num1 * 4,
                        label: `${this.num1 * 3} - ${this.num1 * 4}`,
                        color: "#f78218",
                        opacity: 1
                        // color: "#4a383f"
                    },
                    {
                        gte: this.num1 * 2,
                        lte: this.num1 * 3,
                        label: `${this.num1 * 2}-${this.num1 * 3}`,
                        color: "#f2962b",
                        opacity: 1
                        // color: "#303345"
                    }, {
                        gte: this.num1,
                        lte: this.num1 * 2,
                        label: `${this.num1}-${this.num1 * 2}`,
                        color: '#f4a52f',
                        opacity: 1
                        // color: "#192f4d"
                    }, {
                        gte: 1,
                        lte: this.num1,
                        label: `1-${this.num1}`,
                        // color: "#112e50"
                        color: "#fadb72",
                        opacity: 1
                    }, {
                        gte: 0,
                        lte: 0,
                        // color: "#112e50"
                        color: "#10355F",
                        opacity: .4,
                    }
                    ],
                    // },



                },
                // legend: {

                // }

            };
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            // this.chart.on('click', (params) => {
            //     // if (params.name == '锡林郭勒盟') {
            //     this.region.features.forEach((item) => {
            //         if (item.properties.name == params.name) {
            //             var a = this.mapData.filter(item => {
            //                 if (item.name == params.name) {
            //                     this.farmerAreaDis.map = item.childMap
            //                     this.farmerData = {
            //                         value: item.account,
            //                         properties: item.proportion
            //                     }
            //                 }
            //             })
            //             // this.dataInfo = a[0]
            //             console.log(a, 'a');
            //             var adcode = item.properties.adcode
            //             this.$http({
            //                 url: 'screenapp-service/map/child/data',
            //                 //请求方式
            //                 method: 'post',
            //                 //传递的参数
            //                 data: {
            //                     adcode: adcode,
            //                 },
            //             }).then(res => {
            //                 if (res.data.code === 200) {
            //                     // this.region = res.data.result.json;
            //                     // console.log(res.data.result.map, ' res.data.result.json');
            //                     if (this.chart != null && this.chart != "" && this.chart != undefined) {
            //                         this.isShowMap = false
            //                         this.chart.clear()
            //                     }
            //                     this.$nextTick(() => {
            //                         this.isShowMap = true
            //                         this.$nextTick(() => {
            //                             this.goBackShow = true
            //                             this.draw(res.data.result.map, this.farmerAreaDis.map)
            //                             this.flopData()//翻牌数据
            //                         })
            //                     })

            //                     // this.getData()
            //                 }
            //             })
            //         }
            //     })


            // });
        },
        flopData() {
            var reg = new RegExp('%', 'g')
            this.farmerData.properties = Number(this.farmerData.properties.replace(reg, ''))
            if(this.headDate == '/nmzlqlogin'){
                this.farmerData.value=304
            }
            this.config2 = {
                number: [0],
                style: {
                    //这里可以修改默认样式
                    fontSize: 30,//字体大小
                    fill: '#FFE11D'//字体颜色
                }
            }
            this.config3 = {
                number: [0],
                style: {
                    //这里可以修改默认样式
                    fontSize: 30,//字体大小
                    fill: '#FFE11D'//字体颜色
                }
            }
            setTimeout(() => {
                this.farmerData.value=17579
                this.config2 = {
                    number: [this.farmerData.value],
                    // number: [this.total],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 30,//字体大小
                        fill: '#FFE11D'//字体颜色
                    }
                }
                this.config3 = {
                    number: [this.farmerData.properties],
                    content: '{nt}%',
                    style: {
                        //这里可以修改默认样式
                        fontSize: 30,//字体大小
                        fill: '#FFE11D'//字体颜色
                    }
                }
            }, 0)
        }
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.22rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        position: relative;
        padding: .25rem;
        box-sizing: border-box;
        display: flex;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);

        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;


        video {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
        }

        .left {
            width: 6rem;

            .l_t {
                height: 6.85rem;
                background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);

                .line_chart {
                    width: 100%;
                    // height: 4.5rem;
                    height: 4.3rem;
                    margin-top: .5rem;
                }
            }

            .l_b {
                height: 4.9rem;
                background: linear-gradient(180deg, rgba(0, 223, 218, 0) 0%, rgba(0, 241, 238, 0.1) 100%);
                margin-top: .25rem;



                .bar_chart {
                    width: 100%;
                    height: 3.7rem;
                    margin-top: 0.7rem;
                }
            }
        }

        .right {
            width: 17.21rem;
            margin-left: .25rem;

            .top {
                display: flex;

                .map_box {
                    width: 11.23rem;
                    height: 6.85rem;
                    background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);

                    .center {
                        display: flex;
                        margin-top: .8rem;
                        margin-left: .86rem;

                        .text_n {
                            display: flex;
                            flex-direction: column;
                            font-size: 0.2rem;
                            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                            font-weight: 400;
                            color: #00E0DB;

                            span:nth-child(1) {
                                font-size: 0.38rem;
                                font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                                font-weight: bold;
                                color: #FFE11D;
                                // margin-top: .19rem;
                            }

                            span:nth-child(2) {
                                margin-top: .2rem;

                            }
                        }

                        .text_n:nth-child(2) {
                            margin-left: 1.1rem;
                        }
                    }

                    #mapBox {
                        width: 100%;
                        height: 5rem;
                        // margin-top: .5rem; 
                    }
                }

                .ranght {
                    width: 5.74rem;
                    height: 6.85rem;
                    background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);
                    margin-left: .25rem;

                    #pieChart {
                        width: 100%;
                        height: 3.5rem;
                        margin-top: 1rem;
                        cursor: pointer;
                    }

                    .lenged {
                        width: 80%;
                        height: 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                        flex-wrap: wrap;
                        margin-left: 1.2rem;

                        div {
                            width: 50%;
                            cursor: pointer;

                            span:nth-child(1) {
                                display: inline-block;
                                width: .09rem;
                                height: .09rem;
                                border-radius: 50%;
                                // background-color: red;
                            }

                            span:nth-child(2),
                            span:nth-child(3) {
                                font-size: 0.15rem;
                                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                                font-weight: 400;
                                color: #00E0DB;
                                margin-left: .13rem;
                            }
                        }
                    }
                }
            }

            .bottom {
                height: 4.9rem;
                background: linear-gradient(180deg, rgba(0, 223, 218, 0) 0%, rgba(0, 241, 238, 0.1) 100%);
                margin-top: .25rem;

                .total {
                    font-size: 0.2rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #00E0DB;
                    margin-right: .68rem;

                    i {
                        font-style: normal;
                        color: #FFE11D;
                        font-size: .3rem;
                        padding: 0 .2rem;
                    }
                }

                .search {
                    height: .48rem;
                    margin: .19rem 0 .15rem 0;
                    display: flex;
                    align-items: center;
                    position: relative;

                    .btn_1 {
                        font-size: 0.15rem;
                        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                        font-weight: 400;
                        color: #00E0DB;
                        text-align: center;
                        line-height: .48rem;
                        cursor: pointer;
                    }

                    .btn {
                        width: 1.09rem;
                        background: url('../../assets/search\ \(2\).png');
                        background-size: 100% 100%;
                        margin-left: 0.2rem;
                    }

                    .reset_btn {
                        width: 1.09rem;
                        background: url('../../assets/search\ \(3\).png');
                        background-size: 100% 100%;
                        margin-left: 0.2rem;
                    }

                    .left_ {
                        margin-left: 3rem;
                        margin-right: .14rem;
                    }


                    .l_f {
                        width: 0.44rem;
                        height: 0.44rem;
                        background: rgba(255, 255, 255, 0.05);
                        border-radius: 0.08rem;
                        text-align: center;
                        line-height: .44rem;
                        cursor: pointer;
                        color: #7B8A8A;

                        span {
                            width: 0.1rem;
                            height: 0.17rem;
                            font-weight: 700;
                        }

                    }
                }
            }
        }
    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 88%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #00E0DB;
            padding-right: 0.15rem;

            span {
                padding: .05rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        opacity: 1 !important;
    }

    .active_2 {
        background: rgba(255, 255, 255, 0.2) !important;
        opacity: 1;
        color: #00E0DB !important;
    }

    .add {
        display: flex;
        margin-top: .8rem;
        margin-left: .3rem;

        .add_item {
            display: flex;
            flex-direction: column;
            margin-right: 0.2rem;

            div {
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.18rem;
                padding-top: .1rem;

                span:nth-child(2) {
                    margin-left: .54rem;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FF5A0D;
                    line-height: 0.18rem;

                    i {
                        font-style: normal;
                    }
                }

                img {
                    margin-left: .1rem !important;
                }
            }

            .num {
                display: block;
                font-size: 0.38rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #00E0DB;
                // line-height: 0.38rem;
                // padding-top: .11rem;
                // padding-left: .08rem;
            }

            div {
                min-width: 3rem;
            }

        }
    }

    .active_1 {
        color: #00FF9D !important;
    }
}
</style>
<style lang="scss">
.breeder {
    .breeder .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        // width: 2.79rem;
        height: 0.44rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
        //     background: url('../../assets/search\ \(1\).png') no-repeat;
        //    background-position: .1rem,.1rem;
    }


    .header {
        background: rgba(0, 224, 219, 0.08) !important;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        padding: .2rem 0 .4rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        color: #FFC300;
    }

}
</style>